import axios from 'axios';

// AI Scheduler Rating feedback
const ratingFormUrl =
  'https://docs.google.com/forms/d/e/1FAIpQLSd8fRyPpKgqThhiJHIRkRMLLb-cKqKmmNWMIDjjXnKNvQoitw/formResponse';
enum RatingFormKeys {
  userId = 'entry.577930260',
  actionType = 'entry.1790627571',
  rating = 'entry.1193364122',
  appApiRes = 'entry.830765065',
  preferences = 'entry.1105158981',
  currentTime = 'entry.570017597',
  scienceApiReq = 'entry.1082028300',
  scienceApiRes = 'entry.431039372',
  sessionId = 'entry.5599135',
  prompt = 'entry.939936429',
}

interface SubmitRatingAIFormProps {
  userId: string;
  actionType: string;
  rating: string;
  appApiRes: string;
  preferences: string;
  currentTime: string;
  scienceApiReq: string;
  scienceApiRes: string;
  sessionId?: string;
  prompt?: string;
  onFinish?: () => void;
}

export const submitRatingAIForm = async ({
  userId,
  actionType,
  rating,
  appApiRes,
  preferences,
  currentTime,
  scienceApiReq,
  scienceApiRes,
  sessionId,
  prompt,
  onFinish = () => void 0,
}: SubmitRatingAIFormProps) => {
  const formData = new FormData();
  formData.append(RatingFormKeys.userId, userId);
  formData.append(RatingFormKeys.actionType, actionType);
  formData.append(RatingFormKeys.rating, rating);
  formData.append(RatingFormKeys.appApiRes, appApiRes);
  formData.append(RatingFormKeys.preferences, preferences);
  formData.append(RatingFormKeys.currentTime, currentTime);
  formData.append(RatingFormKeys.scienceApiReq, scienceApiReq);
  formData.append(RatingFormKeys.scienceApiRes, scienceApiRes);
  if (sessionId) {
    formData.append(RatingFormKeys.sessionId, sessionId);
  }
  if (prompt) {
    formData.append(RatingFormKeys.prompt, prompt);
  }
  try {
    await axios.post(ratingFormUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: '*/*',
      },
      transformRequest: (data) => {
        return data;
      },
    });
  } catch (error) {
    console.error('Error', 'Failed to submit feedback', error);
  } finally {
    onFinish();
  }
};
